import { useState, useEffect } from "react";

const TOUR_KEY = "quickFilterTourSeen";

export const useQuickFilterTour = (): {
    showTour: boolean;
    setShowTour: (show: boolean) => void;
    completeTour: () => void;
    startTour: () => void;
} => {
    const [showTour, setShowTour] = useState(false);

    useEffect(() => {
        const hasSeenTour = localStorage.getItem(TOUR_KEY);
        if (!hasSeenTour) {
            const timer = setTimeout(() => setShowTour(true), 2000);
            return () => clearTimeout(timer);
        }
    }, []);

    const completeTour = () => {
        localStorage.setItem(TOUR_KEY, "true");
        setShowTour(false);
    };

    const startTour = () => {
        setShowTour(true);
    };

    return { showTour, setShowTour, completeTour, startTour };
};
